import { render, staticRenderFns } from "./index.vue?vue&type=template&id=741454cd&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=741454cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741454cd",
  null
  
)

export default component.exports